document.addEventListener("DOMContentLoaded", () => {
  const filterList = document
    .querySelector(".articles-filter")
    .querySelectorAll("li");
  const articlesList = document
    .querySelector(".articles-content")
    .querySelectorAll("li");
  let activeFilter = document.querySelector(".is-active");
  filterList.forEach((filter) => {
    filter.addEventListener("click", (event) => {
      hideAllArticles();
      filter.classList.add("is-active");
      activeFilter.classList.remove("is-active");
      activeFilter = filter;

      if (filter.dataset.blogHandle == "all-articles") {
        articlesList.forEach((article) => {
          article.classList.add("visible");
        });
        return;
      }
      showArticles_byBlogHandle(filter.dataset.blogHandle);
    });
  });
  function hideAllArticles() {
    articlesList.forEach((article) => {
      article.classList.remove("visible");
    });
  }
  function showArticles_byBlogHandle(blog_handle) {
    articlesList.forEach((article) => {
      if (article.dataset.blogHandle == blog_handle) {
        article.classList.add("visible");
      }
    });
  }
});
